import React from 'react';

const Terms = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Terms of Service</h1>
        <p style={styles.lastUpdated}>Last Updated: May 2026</p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. About Sytch</h2>
          <p style={styles.text}>
            Sytch LLC ("Sytch," "we," "us," or "our") is a communications
            platform - not a transportation company. Sytch provides technology
            that allows registered users to post, discover, and coordinate ride-sharing
            arrangements between private individuals who are already planning to travel
            in the same direction. Sytch does not provide transportation, employ
            drivers, own or operate vehicles, or set prices between users.
          </p>
          <p style={styles.text}>
            By creating an account or using the Sytch platform in any way, you
            agree to be bound by these Terms of Service.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Eligibility</h2>
          <p style={styles.text}>To use Sytch you must:</p>
          <p style={styles.text}>• Be at least 18 years of age</p>
          <p style={styles.text}>• Hold a valid government-issued ID</p>
          <p style={styles.text}>• Pass Sytch's required background check verification</p>
          <p style={styles.text}>• If posting as a Driver, hold a valid driver's license
          and maintain legally required vehicle insurance</p>
          <p style={styles.text}>• Not be prohibited from using such services under
          applicable law</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Verified Membership</h2>
          <p style={styles.text}>
            All users must pay a one-time $19.99 Verified Membership fee before
            posting or booking trips. This fee covers the cost of a background check
            conducted by our third-party provider, Checkr, Inc. This fee is
            <strong> non-refundable once the background check has been initiated</strong>,
            regardless of the outcome.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Sytch Is a Platform, Not a Carrier</h2>
          <p style={styles.text}>
            Sytch is a neutral technology platform that facilitates communication
            between private individuals. Sytch is not a transportation carrier,
            transportation network company (TNC), taxi service, or common carrier
            of any kind. Drivers are private individuals sharing rides in their
            personal vehicles. They are not employees, agents, or representatives
            of Sytch.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Insurance</h2>
          <p style={styles.text}>
            Personal automobile insurance policies typically do not cover incidents
            that occur during ride-sharing activities. Sytch does not provide
            insurance coverage of any kind. Drivers are solely responsible for
            understanding their insurance policy terms. By using Sytch, both
            Drivers and Riders acknowledge this limitation and accept personal
            responsibility for their participation.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Cost Sharing</h2>
          <p style={styles.text}>
            Contributions between Drivers and Riders are voluntary cost-sharing
            arrangements for fuel, tolls, and trip expenses - not payment for
            commercial transportation. Contributions may be any amount from zero
            to a user-negotiated amount. Sytch charges a 10% platform fee
            on paid transactions. Sytch is not responsible for payment disputes
            between users.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. User Conduct</h2>
          <p style={styles.text}>All users agree to:</p>
          <p style={styles.text}>• Provide accurate and truthful information</p>
          <p style={styles.text}>• Treat all other users with respect and dignity</p>
          <p style={styles.text}>• Not use the platform for any unlawful purpose</p>
          <p style={styles.text}>• Not discriminate against other users based on
          any protected characteristic</p>
          <p style={styles.text}>• Report any safety concern to Sytch immediately</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>8. Limitation of Liability</h2>
          <p style={styles.text}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, SYTCH SHALL NOT BE LIABLE
            FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
            ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE PLATFORM OR ANY TRIP
            ARRANGED THROUGH THE PLATFORM. SYTCH'S TOTAL LIABILITY SHALL NOT EXCEED
            THE GREATER OF THE PLATFORM FEES PAID BY YOU IN THE SIX MONTHS PRECEDING
            THE CLAIM OR ONE HUNDRED DOLLARS ($100).
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>9. Dispute Resolution</h2>
          <p style={styles.text}>
            Any dispute arising out of or relating to these Terms shall be resolved
            by binding individual arbitration. YOU WAIVE YOUR RIGHT TO A JURY TRIAL
            AND YOUR RIGHT TO PARTICIPATE IN A CLASS ACTION LAWSUIT.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>10. Contact</h2>
          <p style={styles.text}>
            Sytch LLC<br />
            Email: support@sytch.app<br />
            Website: sytch.app
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: '#f0f2f5',
    minHeight: '100vh',
    padding: '40px 20px',
    fontFamily: 'Arial, sans-serif',
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    background: 'white',
    borderRadius: '16px',
    padding: '48px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  },
  title: {
    fontSize: '36px',
    fontWeight: 'bold',
    color: '#1a1a2e',
    margin: '0 0 8px 0',
  },
  lastUpdated: {
    color: '#999',
    fontSize: '14px',
    margin: '0 0 40px 0',
  },
  section: {
    marginBottom: '32px',
  },
  heading: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1a1a2e',
    margin: '0 0 12px 0',
  },
  text: {
    color: '#555',
    lineHeight: '1.7',
    margin: '0 0 12px 0',
    fontSize: '15px',
  },
};

export default Terms;